// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.themeBlock__F0ngh {
  grid-column: 3;
  height: 100%;
}
@media (max-width: 1300px) {
  .themeBlock__F0ngh {
    grid-column: 1/3;
  }
}

.themeBlockTitle__HuGCY {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.themeBlockContainer__XAv1h {
  min-height: 120px;
  height: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 20px;
  margin-top: 10px;
  padding: 20px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}
@media (max-width: 1300px) {
  .themeBlockContainer__XAv1h {
    min-height: 58px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.themeBlockDescr__ajQsM {
  color: var(--tables-primary-row-text-main);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-box-trim: none;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Profile/components/ThemeBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,cAAA;EACA,YAAA;AAzEF;AA2EE;EAJF;IAKI,gBAAA;EAxEF;AACF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAxEF;;AA2EA;EACE,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,qDAAA;EACA,wCAAA;AAxEF;AA0EE;EAZF;IAaI,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;EAvEF;AACF;;AA0EA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAvEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.themeBlock {\n  grid-column: 3;\n  height: 100%;\n\n  @media (max-width: 1300px) {\n    grid-column: 1/3;\n  }\n}\n\n.themeBlockTitle {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.themeBlockContainer {\n  min-height: 120px;\n  height: calc(100% - 24px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  row-gap: 20px;\n  margin-top: 10px;\n  padding: 20px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n\n  @media (max-width: 1300px) {\n    min-height: 58px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n.themeBlockDescr {\n  color: var(--tables-primary-row-text-main);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  text-box-trim: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeBlock": `themeBlock__F0ngh`,
	"themeBlockTitle": `themeBlockTitle__HuGCY`,
	"themeBlockContainer": `themeBlockContainer__XAv1h`,
	"themeBlockDescr": `themeBlockDescr__ajQsM`
};
module.exports = ___CSS_LOADER_EXPORT___;
